import Grid, { gridClasses } from "components/primitives/Grid";
import ButtonBase from "@mui/material/ButtonBase";
import { grey } from "@mui/material/colors";
import { styled } from "@mui/material";

export const ExerciseCardGrid = styled(Grid)(({ theme }) => {
  const border = `1px solid ${grey[300]}`;

  return {
    [`& > .${gridClasses.container}`]: {
      border,
      borderBottomWidth: 0,
    },
    [`&:nth-of-type(1) > .${gridClasses.container}`]: {
      // Athlete Name
      border: "1px dashed transparent",
    },
    [`&:nth-of-type(2) > .${gridClasses.container}`]: {
      // First Measurement
      border,
      borderTopRightRadius: theme.spacing(1.5),
      borderTopLeftRadius: theme.spacing(1.5),
      borderBottomWidth: 0,
    },
    [`&:last-of-type > .${gridClasses.container}`]: {
      // Last Measurement
      border,
      borderBottomRightRadius: theme.spacing(1.5),
      borderBottomLeftRadius: theme.spacing(1.5),
    },
  };
});

export const AthleteCardButton = styled(ButtonBase)(({ theme }) => ({
  // TODO: remove `!important` after MuiV5 migration completion
  justifyContent: "flex-start!important",
  borderRadius: theme.spacing(1.5),
}));
